import { render, staticRenderFns } from "./xsmYinLiuDialog.vue?vue&type=template&id=11bc83d6&scoped=true&"
import script from "./xsmYinLiuDialog.vue?vue&type=script&lang=js&"
export * from "./xsmYinLiuDialog.vue?vue&type=script&lang=js&"
import style0 from "./xsmYinLiuDialog.vue?vue&type=style&index=0&id=11bc83d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bc83d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11bc83d6')) {
      api.createRecord('11bc83d6', component.options)
    } else {
      api.reload('11bc83d6', component.options)
    }
    module.hot.accept("./xsmYinLiuDialog.vue?vue&type=template&id=11bc83d6&scoped=true&", function () {
      api.rerender('11bc83d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "meibao-insure/src/components/dialog/xsmYinLiuDialog.vue"
export default component.exports